import {
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import "./AllPatients.css";
import MainSideNavPanel from "../../molecules/CgMainSideNavPanel/MainSideNavPanel";
import API from "../../services/rest/api";
import ChatAppV2 from "../ChatAppV2/ChatAppV2";
import CgPatientList from "../CgPatientList/CgPatientList";

const AllPatients: FunctionComponent = () => {
  const [userDetails, setUserDetails] = useState<any>(null);
  const [journey, setJourney] = useState<any>("all-patients");
  const [chatAppUrl, setChatAppUrl] = useState<string>("");
  const location: any = useLocation();
  const params = useParams();

  useEffect(() => {
    const token: any = params.token;
    localStorage.setItem(
      "token",
      location.state?.token === ":token" || location.state?.token === undefined
        ? token
        : location.state?.token
    );
    sessionStorage.setItem(
      "token",
      location.state?.token === ":token" || location.state?.token === undefined
        ? token
        : location.state?.token
    );
    setJourney(
      location.state?.journey === "" || location.state?.journey === undefined
        ? journey
        : location.state?.journey
    );
  }, []);


  useEffect(() => {
    getProfileDetails();
  }, [journey, params]);

  // Separate useEffect to construct chat app URL after userDetails is loaded
  useEffect(() => {
    if (userDetails) {
      const chatAppUrlFromEnv = process.env.REACT_APP_CHAT_APP_URL;

      if (chatAppUrlFromEnv && userDetails?.health_coach_id) {
        const fullName = `${userDetails?.first_name || ""} ${
          userDetails?.last_name || ""
        }`.trim();
        const hc_type = userDetails?.chief_hc === "Y" ? "chief" : "hc";

        // Properly encode URL parameters - add userId as PubNub expects it
        const constructedUrl = `${chatAppUrlFromEnv}?sender=${encodeURIComponent(
          userDetails.health_coach_id
        )}&subscriberId=${encodeURIComponent(
          userDetails.health_coach_id
        )}&hc_type=${encodeURIComponent(
          hc_type
        )}&subscriberName=${encodeURIComponent(fullName)}`;

        setChatAppUrl(constructedUrl);
      } else {
        console.error("Missing required data for chat app:", {
          hasUrl: !!chatAppUrlFromEnv,
          hasHealthCoachId: !!userDetails?.health_coach_id,
          userDetails,
        });
      }
    }
  }, [userDetails]);

  //funtion to get profile details
  const getProfileDetails = async () => {
    try {
      const userInfo = await API.GetProfileDetails();
      localStorage.setItem("userInfo", JSON.stringify(userInfo?.data));
      setUserDetails(userInfo?.data);
    } catch (error) {
      console.log("error", error);
    }
  };


  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        borderTop: "1px solid #eaeaea",
      }}
    >
      <div className="flex h-full">
        <MainSideNavPanel
          onTabClick={(tab) => setJourney(tab)}
          journey={journey}
        />
        <div className="main-content-container">
          {journey === "all-patients" && <CgPatientList isVerified={false} />}
          {journey === "verified-patients" && <CgPatientList isVerified={true} />}
          {journey === "chat-app" && (
            <div
              className="chat-app-container"
              style={{ width: "100%", height: "100%" }}
            >
              {chatAppUrl && chatAppUrl.includes("sender=") ? (
                <iframe
                  key={chatAppUrl}
                  className="chat-app"
                  src={chatAppUrl}
                  title="Chat App"
                  style={{ border: "none", height: "100%", width: "100%" }}
                  allow="notifications"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div>Loading Chat App...</div>
                </div>
              )}
            </div>
          )}
          {journey === "chat-app-v2" && (
            <div className="flex-1">
              <div className="h-full">
                <ChatAppV2 />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllPatients;
